import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DriverHistory } from '../modelinterfaces/driver-history.model';
import { PageParams } from '../modelinterfaces/page-params.model';
import { Page } from '../modelinterfaces/page.model';
import { HttpParamsUtil } from '../utils/http-params-util';
import { EnvironmentHelper } from './environment-helper';

@Injectable({
  providedIn: 'root'
})

export class DriverHistoryService {

  constructor(private http: HttpClient, private environmentHelper: EnvironmentHelper) {
  }

  public getByUnit(unitId: number, pageParams: PageParams, filter: Map<string, string>): Observable<Page<DriverHistory>> {
    const url = `${this.environmentHelper.urlV2}/driverHistory/page/unit/${unitId}`;
    const params: HttpParams = HttpParamsUtil.createByPageAndFilter(pageParams, filter);
    return this.http.get<Page<DriverHistory>>(url, {params: params})
      .pipe(
        map(value => {
          value.urlParams = params;
          return DriverHistory.pageableValueOf(value);
        })
      );
  }

  public getByDriver(driverId: number, pageParams: PageParams, filter: Map<string, string>): Observable<Page<DriverHistory>> {
    const url = `${this.environmentHelper.urlV2}/driverHistory/page/driver/${driverId}`;
    const params: HttpParams = HttpParamsUtil.createByPageAndFilter(pageParams, filter);
    return this.http.get<Page<DriverHistory>>(url, {params: params})
      .pipe(
        map(value => {
          value.urlParams = params;
          return DriverHistory.pageableValueOf(value);
        })
      );
  }
}
